var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioHoverBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "radio button mini"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 7,
    height: 7,
    stroke: "#005BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 2.5,
    y: 2,
    width: 4,
    height: 4,
    fill: "#005BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioHoverBlue);
export default __webpack_public_path__ + "static/media/radioHoverBlue.768d7a70d50a4215d6ca406c66e19cbe.svg";
export { ForwardRef as ReactComponent };